import React, { useEffect, useState } from "react"
import { v4 as uuidv4 } from "uuid"
import Header from "../components/Header"
import DefaultConsent from "../components/consent/DefaultConsent"
import StocksConsent from "../components/consent/StocksConsent"
import GamingConsent from "../components/consent/GamingConsent"
import FundsConsent from "../components/consent/FundsConsent"
import Loading from "./Loading"
import Unavailable from "./Unavailable"
import Maintenance from "./Maintenance"
import NotFound from "../components/NotFound"
import {
  getTicket,
  retrieveTicket,
  storeTicket,
} from "../services/ticket-service"
import { getConsent } from "../services/consent-service"
import { setUrl } from "../services/session-service"
import config from "../config"

const isInternalApp = (tpId) => config.internalAppsList.indexOf(tpId) !== -1

function Home() {
  const id = new URLSearchParams(window.location.search).get("ticketId")
  const tpId = new URLSearchParams(window.location.search).get("tpId")
  const rrn = uuidv4()

  // USE STATES ----------
  const [ticket, setTicket] = useState({})
  const [consents, setConsents] = useState([])
  const [optIn, setOptIn] = useState()
  const [load, setLoad] = useState("") // triggers loading of form
  const [ticketErr, setTicketErr] = useState()
  const [consentRequired, setConsentRequired] = useState(true)
  // setState Prop
  const redirect = () => {
    setOptIn(true)
  }

  useEffect(() => {
    // Load existing ticket from storage, if exists
    const storedTicket = retrieveTicket(id)
    if (storedTicket && storedTicket.consumeId !== undefined) {
      if (storedTicket.isSessionInitialized) {
        window.history.forward()
        setTimeout(() => {
          setTicketErr({
            message: `Your session with ${storedTicket.tp.name} has expired`,
          })
        }, 5000)
        return
      }

      setTicket(storedTicket)
      return
    }

    // get ticket ---
    getTicket(id, rrn)
      .then((response) => {
        setTicket(response)
        storeTicket(response)
        if (response.tp.id !== tpId) {
          setTicketErr({ message: "Invalid tpId" })
        }
        console.log(response) // eslint-disable-line
      })
      .catch((error) => {
        console.log(error) // eslint-disable-line
        setTicketErr(error?.response?.data)
      })
  }, []) // eslint-disable-line

  // GET CONSENT IF ----------
  useEffect(() => {
    if (Object.keys(ticket).length) {
      if (isInternalApp(ticket.tp.id)) {
        setConsentRequired(false)
        return
      }

      getConsent(id, rrn)
        .then((response) => {
          const cons = response.consents
          setConsents(cons)
          if (cons.some((consent) => consent.optIn === false)) {
            setOptIn(false)
          } else {
            setOptIn(true)
          }
        })
        .catch((error) => {
          console.log(error) // eslint-disable-line
          setTicketErr(error)
        })
    }
  }, [ticket]) // eslint-disable-line react-hooks/exhaustive-deps

  // // LOAD PAGE IF ----------
  useEffect(() => {
    if (!consentRequired) {
      setLoad(true)
    } else if (ticket.tp && ticket.client && optIn !== undefined) {
      console.log(optIn) // eslint-disable-line
      setLoad(true)
    }
  }, [consentRequired, ticket, optIn]) // eslint-disable-line react-hooks/exhaustive-deps

  // LOAD REDIRECT IF ----------
  useEffect(() => {
    if (!consentRequired || optIn) {
      setUrl(id, rrn, ticket.consumeId)
        .then((response) => {
          ticket.isSessionInitialized = true
          storeTicket(ticket)
          if (config.api.redirect === "dev") {
            // eslint-disable-next-line
            console.log(`redirect to: ${response.sessionInitUrl}`)
          } else {
            window.location.replace(response.sessionInitUrl)
          }
        })
        .catch((error) => {
          console.log("err", error) // eslint-disable-line
          setTicketErr(error)
        })
    }
  }, [consentRequired, optIn]) // eslint-disable-line react-hooks/exhaustive-deps

  // --- RENDERING --- //
  const errorPageRendering = (error) => {
    switch (error?.code) {
      case "TPM-MAINTENANCE":
        return <Maintenance error={error} />
      case "TPM-WHITELIST":
        return <Unavailable />
      default:
        return <NotFound err={error.message} />
    }
  }

  return (
    <div className="App">
      {ticketErr && errorPageRendering(ticketErr)}
      {load ? (
        <div style={ticket.client && ticket.tp ? {} : { display: "none" }}>
          <Header merchant={ticket.tp} client={ticket.client} />
          {!consentRequired || optIn ? (
            <>
              <p className="redirect-message">
                Redirecting you to {ticket.tp.name}
              </p>
              <Loading />
            </>
          ) : (
            <div>
              {ticket.tp.category === "funds" && (
                <FundsConsent
                  id={id}
                  rrn={rrn}
                  ticket={ticket}
                  consents={consents}
                  redirect={redirect}
                />
              )}
              {ticket.tp.category === "stocks" && (
                <StocksConsent
                  id={id}
                  rrn={rrn}
                  ticket={ticket}
                  consents={consents}
                  redirect={redirect}
                />
              )}
              {ticket.tp.category === "gaming" && (
                <GamingConsent
                  id={id}
                  rrn={rrn}
                  ticket={ticket}
                  consents={consents}
                  redirect={redirect}
                />
              )}
              {!ticket.tp.category && (
                <DefaultConsent
                  id={id}
                  rrn={rrn}
                  ticket={ticket}
                  consents={consents}
                  redirect={redirect}
                />
              )}
            </div>
          )}
        </div>
      ) : (
        <Loading />
      )}
    </div>
  )
}

export default Home
